import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const BusinessNameInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Razón social">
      {getFieldDecorator("businessName", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa la razón social."
          }
        ],
        initialValue: implementerProfile?.businessName
      })(
        <Input
          disabled={isBusy}
          id="businessName"
          name="businessName"
          placeholder="Razón social"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
